import React from "react";
import { ATTRS } from "../sport/projection";

export default function RadarChart({ stats }) {
  const cx = 150,
    cy = 150,
    r = 90,
    labelR = 118;

  // One axis per sport attribute, evenly spaced, starting at 12 o'clock.
  const axisAngle = (i) => -Math.PI / 2 + (i * 2 * Math.PI) / ATTRS.length;

  const point = (value, i, radius = r) => {
    const angle = axisAngle(i);
    const dist = (value / 100) * radius;
    return {
      x: cx + dist * Math.cos(angle),
      y: cy + dist * Math.sin(angle),
    };
  };

  const polygonPoints = ATTRS.map((attr, i) => {
    const p = point(stats[attr] || 0, i);
    return `${p.x},${p.y}`;
  }).join(" ");

  const gridLevels = [25, 50, 75, 100];

  return (
    <svg
      viewBox="0 0 300 300"
      className="w-full h-auto overflow-visible"
      aria-label="Team stats radar"
    >
      {/* Grid hexagons */}
      {gridLevels.map((level) => {
        const points = ATTRS.map((_, i) => {
          const p = point(level, i);
          return `${p.x},${p.y}`;
        }).join(" ");
        return (
          <polygon
            key={level}
            points={points}
            fill="none"
            stroke="rgb(39 39 42)"
            strokeWidth="1"
          />
        );
      })}

      {/* Axis lines */}
      {ATTRS.map((_, i) => {
        const p = point(100, i);
        return (
          <line
            key={i}
            x1={cx}
            y1={cy}
            x2={p.x}
            y2={p.y}
            stroke="rgb(39 39 42)"
            strokeWidth="1"
          />
        );
      })}

      {/* Team polygon */}
      <polygon
        points={polygonPoints}
        fill="rgb(16 185 129 / 0.25)"
        stroke="rgb(52 211 153)"
        strokeWidth="2"
        strokeLinejoin="round"
      />

      {/* Stat value dots */}
      {ATTRS.map((attr, i) => {
        const p = point(stats[attr] || 0, i);
        return (
          <circle key={i} cx={p.x} cy={p.y} r="3" fill="rgb(52 211 153)" />
        );
      })}

      {/* Labels */}
      {ATTRS.map((attr, i) => {
        const angle = axisAngle(i);
        const lx = cx + labelR * Math.cos(angle);
        const ly = cy + labelR * Math.sin(angle);
        return (
          <g key={attr}>
            <text
              x={lx}
              y={ly - 5}
              fill="rgb(113 113 122)"
              textAnchor="middle"
              dominantBaseline="middle"
              fontSize="12"
              fontWeight="700"
              letterSpacing="0.05em"
            >
              {attr}
            </text>
            <text
              x={lx}
              y={ly + 12}
              fill="rgb(228 228 231)"
              textAnchor="middle"
              dominantBaseline="middle"
              fontSize="12"
              fontWeight="600"
            >
              {stats[attr] || 0}
            </text>
          </g>
        );
      })}
    </svg>
  );
}
